import React from "react"
import PropTypes from "prop-types"
import clsx from "clsx"
import CheckIcon from "@mui/icons-material/Check"
import CloseIcon from "@mui/icons-material/Close"
import WarningIcon from "@mui/icons-material/Warning"
import InfoIcon from "@mui/icons-material/Info"
import IconButton from "@mui/material/IconButton"
import { makeStyles } from "@mui/styles"

const VARIANT_COLOR = {
  success: "#51C473",
  error: "#F44A5F",
  warning: "#FFA000",
  info: "#1976d2",
}

// For the badge inside the white circle: success=check, all others=close (X)
const BADGE_ICON = {
  success: CheckIcon,
  error: CloseIcon,
  warning: WarningIcon,
  info: InfoIcon,
}

const useStyles = makeStyles({
  root: {
    maxWidth: "calc(100vw - 48px)",
    minHeight: 40,
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "9px 14px",
    borderRadius: 4,
    color: "#fff",
    fontSize: 14,
    lineHeight: "22px",
    boxShadow: "0 4px 14px rgba(0,0,0,.24)",
    boxSizing: "border-box",
  },
  success: { backgroundColor: "#51C473" },
  error: { backgroundColor: "#F44A5F" },
  warning: { backgroundColor: "#FFA000" },
  info: { backgroundColor: "#1976d2" },
  badge: {
    width: 22,
    height: 22,
    flex: "0 0 22px",
    borderRadius: "50%",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "flex-start",
    marginTop: 1,
  },
  badgeIcon: {
    fontSize: "14px !important",
    fontWeight: "bold",
  },
  message: {
    flex: 1,
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
  closeButton: {
    marginLeft: 4,
    padding: 4,
    color: "#fff",
    opacity: 0.95,
    alignSelf: "flex-start",
    marginTop: -2,
    "&:hover": { background: "rgba(255,255,255,.15)" },
  },
  closeIcon: {
    fontSize: "18px !important",
  },
})

const MySnackbarContentWrapper = React.forwardRef((props, ref) => {
  const { className, message, onClose, variant, ...other } = props
  const classes = useStyles()
  const BadgeIcon = BADGE_ICON[variant]
  const color = VARIANT_COLOR[variant]

  return (
    <div
      ref={ref}
      className={clsx(classes.root, classes[variant], className)}
      {...other}
    >
      <span className={classes.badge}>
        <BadgeIcon className={classes.badgeIcon} style={{ color }} />
      </span>
      <span className={classes.message}>{message}</span>
      {onClose && (
        <IconButton
          className={classes.closeButton}
          aria-label="Fermer"
          onClick={onClose}
          size="small"
        >
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      )}
    </div>
  )
})

MySnackbarContentWrapper.propTypes = {
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired,
}

export default MySnackbarContentWrapper
